<template>
  <div>
    <Placeholder v-if="loading" />
    <div v-else>
      <div class="ui info message">
        <i class="bolt icon"></i>
        无需登录账号，扫描二维码（或者访问下面的链接）快速给自己传文件。
      </div>
      <div>
        <img :src="qrcode_url" class="ui bordered image my-8 mx-auto" alt=""/>
        <div class="text-center">
          <a data-tooltip="点击复制" data-position="bottom center" class="ui labeled icon teal large button" @click="copy_to_clipboard($event, ingress.url, '链接')">
            <i class="copy icon"></i>
            {{ ingress.url }}
          </a>
        </div>
      </div>
      <hr class="my-8">
      <div class="mb-8">
        <div class="ui middle aligned two column stackable grid">
          <div class="column">
            <div class="ui small basic blue label">
              {{ bytes_to_human(client.quota.used_ingress) }} / {{ bytes_to_human(client.quota.total_ingress) }}
            </div>
            <span class="ml-4" v-if="entries.length">
              {{ entries.length }}个项目
            </span>
            <span class="ml-4" v-else>
              上传的项目会在这里显示
            </span>
            <a class="ml-4" @click="refresh_data">
              <i class="sync alternate icon"></i>
              刷新
            </a>
          </div>
          <div class="column text-right">
            <a class="ui icon small button" :class="{ loading: delete_all_busy }"
               @click="show_modal('delete-all-modal')">
              <i class="trash alternate icon"></i>
              清空
            </a>
            <Modal id="delete-all-modal" @ok="delete_all" title="清除文件闪传">
              确定要删除全部的项目吗？
            </Modal>
          </div>
        </div>
        <Placeholder v-if="refreshing" class="mt-4" />
        <div v-else v-for="(entry, index) in entries" :key="index" class="ui entry segment">
          <div class="mb-2 ui two column middle aligned grid title">
            <div class="column text-lg">
              {{ format_time(entry.created) }}
            </div>
            <div class="column text-right">
              <span v-if="entry.saving" class="mr-2">
                <div class="ui small active inline loader"></div>
              </span>
              <button v-else-if="has_files(entry)"
                      title="保存文件到我的网盘"
                      data-tooltip="保存文件到我的网盘"
                      class="ui teal icon button tooltip"
                      @click="show_save(entry)">
                <i class="save icon"></i>
              </button>
              <button class="ui icon button tooltip" data-tooltip="删除" @click="delete_entry(entry)">
                <i class="trash icon"></i>
              </button>
            </div>
          </div>
          <template v-if="entry.data">
            <div v-if="entry.data.text" class="ui segment mb-4 entry-text">
              <div class="ui top attached label">
                消息
              </div>
              <div v-html="entry.data.text">
              </div>
            </div>
            <div class="break-all">
              <ul class="ui bulleted list">
                <li v-for="(file, index) in entry.data.files" :key="index">
                  <strong>
                    {{ file.path }}
                  </strong>
                  <span class="ml-4">
                    {{ bytes_to_human(file.size) }}
                  </span>
                </li>
              </ul>
            </div>
          </template>
        </div>
      </div>
    </div>
    <DirSelectModal id="save-modal" @ok="save($event)" />
  </div>
</template>

<script>

import QRCode from 'qrcode';
import Placeholder from '../components/placeholder';
import DirSelectModal from '../components/dir-select-modal';
import Modal from '../components/modal';

export default {
  name: 'Ingress',
  props: [],
  components: {
    Modal,
    Placeholder,
    DirSelectModal,
  },
  data: function () {
    return {
      loading: true,
      refreshing: false,
      entries: [],
      saving_entry: null,
      delete_all_busy: false,
    };
  },
  computed: {
    space() {
      return this.$store.state.space;
    },
    ingress() {
      return this.$store.state.ingress || {};
    },
    ingress_data() {
      return this.$store.state.ingress_data;
    },
  },
  asyncComputed: {
    qrcode_url() {
      if (this.ingress) {
        return QRCode.toDataURL(this.ingress.url);
      }
    },
  },
  methods: {
    copy_to_clipboard(e, text, item_name='') {
      this.$gtag.event('copy-ingress-url', {
        event_category: 'user-action',
      });
      var dummy = document.createElement("textarea");
      e.target.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      e.target.removeChild(dummy);
      this.show_success(item_name + "已复制到剪贴板");
    },
    async delete_all() {
      this.delete_all_busy = true;
      try {
        await this.client.ingress_delete_entries(this.entries.map(e => e.id));
        this.refresh_data();
      } catch (e) {
        this.show_error(this.error_text(e));
      } finally {
        this.delete_all_busy = false;
      }
    },
    has_files(entry) {
      return entry && entry.data && entry.data.files && entry.data.files.length;
    },
    show_save(entry) {
      this.saving_entry = entry;
      this.show_modal('save-modal');
    },
    async save(path) {
      var entry = this.saving_entry;
      entry.saving = true;
      var ps = [];
      var sel_file = [];
      try {
        for (var f of entry.data.files) {
          var rel = this.space.dirname(f.path);
          if (rel) {
            var dir = this.space.path_join(path, rel);
            await this.space.mkdir(dir);
          }
          var fullpath = this.space.path_join(path, f.path);
          var ei = this.client.parse_enc_info(f.enc_info);
          var p = this.space.save_file(fullpath, f.size, f.chunks, ei,
                                       "ingress");
          sel_file.push(this.space.path_last(f.path));
          ps.push(p);
        }
        await Promise.all(ps);
        entry.saving = false;
        this.show_success("成功保存 " + entry.data.files.length + " 个文件！");
        this.$router.push({
          name: 'files',
          query: {
            path: path,
            selected: sel_file.join('|'),
          }
        });
      } catch (e) {
        this.show_error(this.error_text(e));
      }
    },
    async refresh_data() {
      this.refreshing = true;
      this.$store.dispatch('refresh_userinfo');
      var resp = await this.client.ingress_fetch_entries(this.ingress.code);
      this.entries = await this.parse_entries(resp.entries);
      this.refreshing = false;
    },
    async parse_entries(entries) {
      for (var e of entries) {
        try {
          var d = Uint8Array.from(window.atob(e.encrypted_data_base64), c => c.charCodeAt(0))
          var ei = await this.client.ingress_decrypt_entry(this.ingress_data.private_key, d);
          var data = await this.client.get_json(e.root_obj_id, ei);
          e.data = data;
          e.enc_info = ei;
        } catch (e) {
          console.log(e);
        }
      }
      return entries.sort(this.cmp_entry.bind(this));
    },
    cmp_entry(a, b) {
      return b.created - a.created;
    },
    async delete_entry(entry) {
      this.show_confirm({
        message: "确定删除吗？",
        title: "删除闪传数据",
        ok: async () => {
          await this.client.ingress_delete_entry(entry.id);
          this.refresh_data();
        },
      });
    },
  },
  async mounted() {
    await this.$store.dispatch('ingress_init');
    this.loading = false;
    this.refresh_data();
  },
}
</script>

<style>
.entry-text h2 {
  text-align: center;
  font-size: 2rem !important;
}
.entry-text h3 {
  font-size: 1.8rem !important;
}
.entry-text h4 {
  font-size: 1.5rem !important;
}
.entry-text ul {
  list-style: disc;
  margin-left: 2rem;
}
.entry-text ol {
  list-style: decimal;
  margin-left: 2rem;
}
.sm .segment .title {
  padding-left: 14px;
  padding-right: 14px;
}
</style>

